
import { useMemo } from 'react';
import classNames from 'classnames';
import Select from '@UI/Select';
import s from "./index.module.css";
import { ExpandDropDownList } from '@/utils/icons';

const Pagination = ({setPerPage, perPage, currentPage, setCurrentPage, nextPage, prevPage, totalPages}) => {
    
    const options = useMemo(()=>{
        return (
            [
                { label: "20 на странице", value: 20 }, 
                { label: "50 на странице", value: 50 },
                { label: "100 на странице", value: 100 },
                { label: "500 на странице", value: 500 },
                { label: "1000 на странице", value: 1000 },
                // { label: "Все", value: 'all' },
            ]
        )
    }, []);

    const getPaginationItems = () => {
        const paginationItems = [];

        paginationItems.push(1);

        let start = Math.max(2, currentPage - 1);
        let end = Math.min(totalPages - 1, currentPage + 1);

        if (start > 2) {
            paginationItems.push('...');
        }

        for (let i = start; i <= end; i++) {
            paginationItems.push(i);
        }

        if (end < totalPages - 1) {
            paginationItems.push('...');
        }
        
        if (totalPages > 1) {
            paginationItems.push(totalPages);
        }

        return paginationItems;
    };
    const paginationItems = useMemo(()=>{
        return getPaginationItems();
    }, [currentPage, totalPages]);

    const selectedPerPage = useMemo(() => {
        return options.find((option) => option.value === perPage) ?? options[0];
    }, [options, perPage]);

    return (
           <div className={s.wrapper}>
                <Select
                    newDesign
                    className={classNames(s.pageSelection)}
                    options={options}
                    title={selectedPerPage}
                    onChange = {
                        (e) => {
                            setPerPage(e.value);
                            setCurrentPage(1);
                        }
                    }
                />
                <div className={s.wrapperPagination}>
                    <div 
                        className={classNames(s.prev, {[s.disable]:currentPage == '1'})}
                        onClick={prevPage}
                    >
                        <ExpandDropDownList />
                    </div>
                    
                    {paginationItems.map((item, index) => (
                          <div 
                            key={index}
                            onClick={() => {
                                if( typeof item !== 'number' ) return;
                                setCurrentPage(item)
                            }} 
                            className={classNames( {[s.item]: typeof item === 'number'}, {[s.itemActive]: item === currentPage})}>{item}</div>
                    ))}

                    <div
                        className={classNames(s.next, {[s.disable]:currentPage == totalPages})}
                        onClick={nextPage}
                    >
                        <ExpandDropDownList />
                    </div>
                </div>
           </div>
    )
}

export default Pagination;
